import { registerValidator } from 'core/form/validators/registerValidator';

export const arrayNotEmpty = registerValidator(
  'arrayNotEmpty',
  (value) => value?.length,
  'Must select at least one :attribute'
);
